// src/utils/eventBus.js
const eventBus = {
  on(event, callback) {
    document.addEventListener(event, (e) => callback(e.detail));
  },
  
  emit(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  
  dispatch(event, data) {
    document.dispatchEvent(new CustomEvent(event, { detail: data }));
  },
  
  remove(event, callback) {
    document.removeEventListener(event, callback);
  },
  
  off(event, callback) {
    document.removeEventListener(event, callback);
  }
};

export default eventBus;